import BigNumber from "bignumber.js";
import { useAccount, useReadContract, useBlockNumber } from "wagmi";
import convertWeiToEther from "../Utils/convertWeiToEther";
import useCustomContractRead from "./useCustomContractRead";
import IUniswapv2Pair from "../Config/IUniswapv2Pair.json";
import { useEffect, useState } from "react";
import erc20ABI from "../../src/Config/erc20ABI.json"


const useCheckAllowance=({
    tokenAddress, 
    spenderAddress,  
    isLpToken
})=>{
    const { address } = useAccount();
 
    const { data: currentBlock } = useBlockNumber({ watch: true }); // Get the current block number
    

    const { data: checkAllowanceContract, isSuccess, refetch: refetchUserInfo } = useReadContract({
      address: tokenAddress,
      abi: !isLpToken ? erc20ABI : IUniswapv2Pair,
      functionName: "allowance",
      args: [address,spenderAddress],
      enabled: address !== undefined && 
      spenderAddress !== undefined ,
      watch: true
    });
  
  
    useEffect(() => {
      refetchUserInfo()
    }, [currentBlock])



  
    return {
      data:checkAllowanceContract,
      isSuccess:isSuccess
  }

}

export default useCheckAllowance;